<template>
    <div class="ah-page analysis-overview-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>{{ year }} 年度營收總覽</h1>
                    </div>
                    <div class="actions">
                        <el-select v-model="year" @change="updateData">
                            <el-option v-for="item in yearList" :key="item" :label="item" :value="item" />
                        </el-select>
                        <el-tooltip class="item" effect="dark" content="用於補登過去收支後統計有誤差時" placement="top-start">
                            <el-button type="dark" style="margin-left: 10px" @click="updateReCalculateDialogVisible(true)">重算</el-button>
                        </el-tooltip>
                    </div>
                </div>
            </div>
        </div>
        <overview-panel
            :isLoading="isLoading"
            :year="this.year"
            :monthlyRevenueDatas="monthlyRevenueDatas"
            :revenue="pageData.revenue"
            :revenueInfo="pageData.revenueInfo"
            :receivableInfo="pageData.receivableInfo"
            :payableInfo="pageData.payableInfo"
            :salaryInfo="pageData.salaryInfo"
            :variableInfo="pageData.variableInfo"
        >
        </overview-panel>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-header small gray">
                    <div class="panel-title">各月份營業收支</div>
                    <div class="panel-action"></div>
                </div>
                <div class="panel-body">
                    <el-table :data="monthlyTable" row-key="id" border class="monthlyTable ah-analysis-table" :tree-props="{ children: 'children' }" v-loading="isLoading" empty-text="無資料">
                        <el-table-column prop="name" label="項目" fixed width="150">
                            <template slot-scope="scope">
                                <span>
                                    <span>{{ scope.row.name }}</span>
                                    <ah-tip v-if="scope.row.tip != ''">{{ scope.row.tip }}</ah-tip>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m0" label="一月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m0" v-if="scope.$index != 4" round />
                                <span v-else :class="{ success: scope.row.m0 >= 100 }">{{ scope.row.m0 }} %</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m1" label="二月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m1" v-if="scope.$index != 4" round />
                                <span v-else :class="{ success: scope.row.m1 >= 100 }">{{ scope.row.m1 }} %</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m2" label="三月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m2" v-if="scope.$index != 4" round />
                                <span v-else :class="{ success: scope.row.m2 >= 100 }">{{ scope.row.m2 }} %</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m3" label="四月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m3" v-if="scope.$index != 4" round />
                                <span v-else :class="{ success: scope.row.m3 >= 100 }">{{ scope.row.m3 }} %</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m4" label="五月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m4" v-if="scope.$index != 4" round />
                                <span v-else :class="{ success: scope.row.m4 >= 100 }">{{ scope.row.m4 }} %</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m5" label="六月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m5" v-if="scope.$index != 4" round />
                                <span v-else :class="{ success: scope.row.m5 >= 100 }">{{ scope.row.m5 }} %</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m6" label="七月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m6" v-if="scope.$index != 4" round />
                                <span v-else :style="{ success: scope.row.m6 >= 100 }">{{ scope.row.m6 }} %</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m7" label="八月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m7" v-if="scope.$index != 4" round />
                                <span v-else :class="{ success: scope.row.m7 >= 100 }">{{ scope.row.m7 }} %</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m8" label="九月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m8" v-if="scope.$index != 4" round />
                                <span v-else :class="{ success: scope.row.m8 >= 100 }">{{ scope.row.m8 }} %</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m9" label="十月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m9" v-if="scope.$index != 4" round />
                                <span v-else :class="{ success: scope.row.m9 >= 100 }">{{ scope.row.m9 }} %</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m10" label="十一月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m10" v-if="scope.$index != 4" round />
                                <span v-else :class="{ success: scope.row.m10 >= 100 }">{{ scope.row.m10 }} %</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="m11" label="十二月" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.m11" v-if="scope.$index != 4" round />
                                <span v-else :class="{ success: scope.row.m11 >= 100 }">{{ scope.row.m11 }} %</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-alert :closable="false" style="line-height: 150%; margin-top: 15px">
                        <ul>
                            <li>分析來源日期：請款單日期、發票開立日期。</li>
                        </ul>
                    </el-alert>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations } from 'vuex';
import OverviewPanel from './OverviewPanel.vue';

export default {
    name: 'AnalysisOverview',
    components: {
        OverviewPanel,
    },
    data() {
        return {
            isLoading: false,
            year: new Date().getFullYear(),
            incomeColor: '#00ee00',
            payoutColor: '#f8d5b2',
            pageData: {
                revenue: {
                    invoiceUnTaxAmout: 0,
                    noneInvoiceUnTaxAmount: 0,
                    returnAmount: 0,
                    taxAmount: 0,
                    tranInvoioceUnTaxAmount: 0,
                    unTaxedAmount: 0,
                },
                revenueInfo: {
                    income: 0,
                    netIncome: 0,
                    payout: 0,
                },
                receivableInfo: {
                    accountsReceived: 0,
                    accountsReceivable: 0,
                    accruedReceivables: 0,
                },
                payableInfo: {
                    accountsPayable: 0,
                    accountPaid: 0,
                    accruedPayable: 0,
                    pendingPayment: 0,
                    toBeCredited: 0,
                },
                salaryInfo: {
                    amount: 0,
                    fixedSalary: 0,
                    nonFixedSalary: 0,
                    bonus: 0,
                    costs: 0,
                },
                variableInfo: {
                    income: 0,
                    payout: 0,
                    feE_BACK_IN: 0,
                },
            },
            monthlyRevenueDatas: {},
            yearList: [],
            monthlyTable: [],
        };
    },
    created() {
        this.fetchYearOptions().then(() => {
            const currYear = new Date().getFullYear();
            this.year = currYear;
            this.updateData();
        });
    },
    methods: {
        ...mapMutations({
            updateReCalculateDialogVisible: 'globalDialogState/updateReCalculateDialogVisible',
        }),
        fetchYearOptions() {
            return this.$api({
                url: 'FinancialAnalysisPage/GetOverviewYearOptions',
                method: 'GET',
            }).then((resp) => {
                this.status = 'success';
                this.yearList = resp.data.options;

                if (resp.data.options && resp.data.options.length > 0) {
                    this.yearList = resp.data.options;
                } else {
                    this.yearList = [new Date().getFullYear()];
                }

                this.yearList.sort((a, b) => b - a);
            });
        },
        updateData() {
            this.isLoading = true;

            this.$api({
                url: `FinancialAnalysisPage/GetOverview?Year=${this.year}`,
                method: 'GET',
            })
                .then((result) => {
                    console.log('overview', result.data);

                    this.isLoading = false;
                    this.pageData = result.data;

                    // 長條圖
                    const today = new Date();
                    const thisMonth = today.getMonth() + 1;
                    const thisYear = today.getFullYear();

                    const seriesData = {
                        income: [],
                        payout: [],
                        netIncome: [],
                        creditNoteNoTax: [],
                    };

                    result.data.monthlyRevenue.forEach((item) => {
                        if (this.year >= thisYear && item.month > thisMonth) {
                            if (item.income > 0 || item.payout > 0) {
                                seriesData.income.push(item.income);
                                seriesData.payout.push(item.payout);
                                seriesData.netIncome.push(item.netIncome);
                                seriesData.creditNoteNoTax.push(item.creditNoteNoTax);
                            }
                        } else {
                            seriesData.income.push(item.income);
                            seriesData.payout.push(item.payout);
                            seriesData.netIncome.push(item.netIncome);
                            seriesData.creditNoteNoTax.push(item.creditNoteNoTax);
                        }
                    });

                    this.monthlyRevenueDatas = seriesData;

                    // 更新明細表格
                    this.updateMonthlyTable();
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        updateMonthlyTable() {
            const data = [
                {
                    id: '0',
                    name: '營業總收入',
                    tip: '發票金額 - 營業稅 + 營業其他收入 (不含銷貨折讓)',
                },
                {
                    id: '1',
                    name: '營業總支出',
                    tip: '請款單總額（待確認付款＋完成）+ 人事薪資 ＋ 營業其他支出',
                },
                {
                    id: '2',
                    name: '營業淨收',
                    tip: '',
                },
                {
                    id: '3',
                    name: '營收目標 ',
                    tip: '財務 / 營收目標設定',
                },
                {
                    id: '4',
                    name: '營收達成率',
                    tip: '(營業收入 / 營收目標) %',
                },
                {
                    id: '5',
                    name: '發票折讓退回',
                    tip: '依折讓單日期統計',
                },
            ];

            const sourceData = this.pageData.monthlyRevenue;

            for (let i = 0; i < sourceData.length; i += 1) {
                data[0][`m${i}`] = sourceData[i].income;
                data[1][`m${i}`] = sourceData[i].payout;
                data[2][`m${i}`] = sourceData[i].netIncome;
                data[3][`m${i}`] = sourceData[i].revenueTarget;
                data[4][`m${i}`] = Math.round(sourceData[i].fillRate * 1000) / 10;
                data[5][`m${i}`] = sourceData[i].creditNote;
            }

            this.monthlyTable = data;
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.$refs.barchart.resize();
                this.$refs.revenueCart.resize();
                this.$refs.incomeCart.resize();
                this.$refs.paymentCart.resize();
            });
        },
    },
};
</script>
<style lang="scss">
.analysis-overview-page {
    .stats-overview {
        .year-select {
            input {
                font-weight: bold;
                font-size: 12pt;
                width: 140px;
                border-radius: 10px;
            }
        }
    }

    .monthlyTable.ah-analysis-table {
        .money {
            font-weight: normal;

            &.negative {
                color: red;
            }

            &.zero {
                color: #ccc;
            }
        }

        .success {
            color: green;
        }
    }
}
</style>
